import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Button, ButtonToolbar, HelpBlock } from 'react-bootstrap';

import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { left, center, right, justify, Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

function getInitialEditorState(content) {
  if (!content) {
    return EditorState.createEmpty();
  }
  if (Object.keys(content).length === 0 && content.constructor === Object) {
    return EditorState.createEmpty();
  }

  if(content.value === "") {
    return EditorState.createEmpty();
  }
  return EditorState.createWithContent(convertFromRaw(content));
}
class PropertyDescriptionForm extends React.Component {
  constructor(props) {
    super(props);
    const editorState = getInitialEditorState(props.content);

    this.state = {
      editorState,
      pristine: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  onEditorStateChange: Function = editorState => {
    this.setState({
      editorState,
      pristine: false,
    });
  };
  handleSubmit() {
    if(this.props.isAddHotel){
      let values = {}
      values.description = convertToRaw(this.state.editorState.getCurrentContent())
      //let description = convertToRaw(this.state.editorState.getCurrentContent())
      this.props.editHotel(this.props.hotel.hotels[0].id,values)
    }else{
      this.props.onSubmit(convertToRaw(this.state.editorState.getCurrentContent()));
      // this.setState({ isEditing: true });
    }  
  }
  render() {
    const { editorState, pristine } = this.state;
    return (
      <div className="row">
        <div className="col-md-12 hotel-details-description">
          <h4 className="hotel-highlight">{this.props.isRoomDetails ? "Room Details" :"Property Description"} </h4>
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            toolbar={{
              options: ['inline', 'blockType', 'list', 'textAlign', 'history'],
              inline: {
                options: ['bold', 'italic', 'underline'],
              },
              blockType: {
                options: ['Normal', 'H1', 'H2'],
                className: 'fontSizeDrop',
              },
              textAlign: {
                options: ['left', 'center', 'right'],
              },
            }}
            onEditorStateChange={this.onEditorStateChange}
          />
          <FormGroup>
            <ButtonToolbar>
              <Button bsStyle="success" onClick={this.handleSubmit}>
                Save
              </Button>
              <Button bsStyle="success" onClick={this.props.isRoomDetails ? this.props.handleCancelEdit :this.props.handleClose}>
              {this.props.isRoomDetails ? "Cancel" :"Discard Changes"}
              </Button>
            </ButtonToolbar>
          </FormGroup>
        </div>
      </div>
    );
  }
}
PropertyDescriptionForm.propTypes = {
  content: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PropertyDescriptionForm;


// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyDescriptionForm.js